import React from 'react'

import { Route, RouteProps } from 'react-router-dom'

import { AuthenticationHandler } from './AuthenticationHandler'
import Unauthorized from './Unauthorized'
import { useSecurityConfig } from './SecurityConfigProvider'
import { hasAccessToTheView } from '../services/validations'
import { useCredentials } from './CredentialsProvider'

interface Props extends RouteProps {
  view?: string
}

export const ProtectedRoute: React.FC<Props> = ({
  children,
  view,
  ...rest
}) => {
  const { authentication } = useCredentials()
  const { application } = useSecurityConfig()

  return (
    <Route {...rest}>
      {application &&
      view &&
      !hasAccessToTheView(application, view, authentication) ? (
        <Unauthorized />
      ) : (
        <AuthenticationHandler>{children}</AuthenticationHandler>
      )}
    </Route>
  )
}
